import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import Navbar from '../../components/Navbar/Navbar';
import ActivityPicker from './ActivityPicker';
import TimeLogForm from './TimeLogForm';
import TimeLogReport from './TimeLogReport';
import '../Catalogs/Catalogs.css';
import './Activities.css';

function Activities({ initialView }) {
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);
  const [view, setView] = useState(initialView || null);

  useEffect(() => {
    async function fetchProfile() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from('users')
        .select('id, roles(name)')
        .eq('id', user.id)
        .single();
      setUserId(data?.id ?? null);
      setRole(data?.roles?.name ?? null);
    }
    fetchProfile();
  }, []);

  useEffect(() => {
    if (initialView) setView(initialView);
  }, [initialView]);

  function handleBack() {
    setView(null);
    window.history.replaceState(null, '', '/activities');
  }

  return (
    <div className="cat-page">
      <Navbar />
      <main className={view === 'form' ? 'act-main-wide' : 'cat-main'}>
        {!view && <ActivityPicker onSelect={setView} />}
        {view === 'form' && (
          <TimeLogForm userId={userId} role={role} onBack={handleBack} />
        )}
        {view === 'report' && (
          <TimeLogReport userId={userId} role={role} onBack={handleBack} />
        )}
      </main>
    </div>
  );
}

export default Activities;
